import request from '@/utils/request'

/**
 * 支付宝H5支付
 * @param {Object} data - 支付数据
 * @param {string} data.amount - 支付金额
 */
export function alipayH5(data) {
  return request({
    url: '/alipay/h5',
    method: 'post',
    data
  })
}

/**
 * 银联二维码主扫支付
 * @param {Object} data - 支付数据
 * @param {string} data.amount - 支付金额
 */
export function unionpayScan(data) {
  return request({
    url: '/unionpay/scan',
    method: 'post',
    data
  })
}

/**
 * 微信公众号支付
 * @param {Object} data - 支付数据
 * @param {string} data.amount - 支付金额
 */
export function wxpayMp(data) {
  return request({
    url: '/wxpay/mp',
    method: 'post',
    data
  })
}

/**
 * 订单查询
 * @param {Object} data - 查询数据
 */
export function queryOrder(data) {
  return request({
    url: '/query',
    method: 'post',
    data
  })
}

export default {
  alipayH5,
  unionpayScan,
  wxpayMp,
  queryOrder
}
